import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "Our managed NOC services give you an always-on operations team monitoring and maintaining your infrastructure — without the cost of building one in-house.",
    "We watch your systems continuously, respond to alerts and handle routine operations, so your team is freed from firefighting and your uptime stays high.",
];

const FEATURES = [
    { title: "24/7 monitoring", text: "Continuous oversight of servers, networks and services, day and night." },
    { title: "Incident response", text: "Alerts triaged and resolved fast, following clear escalation paths." },
    { title: "Routine operations", text: "Backups, patching and health tasks handled so nothing slips." },
    { title: "Scalable coverage", text: "Support that flexes with your infrastructure as it grows." },
];

const CHECKS = [
    "24/7 infrastructure monitoring",
    "Alert triage & escalation",
    "Backup management",
    "Patch & update management",
    "Reporting & SLAs",
];

export default function NocServices() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Server & Networking" title="Managed NOC Services" eyebrowAs="span">
                    A network operations centre without the overhead — outsourced monitoring and management that keeps your infrastructure running around the clock.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
